// extracted by mini-css-extract-plugin
export default {"DoctorCredentials":"styles_DoctorCredentials__zo0e4","fade-in":"styles_fade-in__kqjGP","loading":"styles_loading__k1wz5"};